var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#291482"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6767 21.0364L11.9035 9.97689C11.9035 9.97689 11.9035 9.97689 11.9035 9.92017C11.5605 9.01272 10.6458 8.38885 9.67386 8.38885C8.35894 8.38885 7.27271 9.46645 7.27271 10.7709C7.27271 11.0545 7.32988 11.3381 7.38705 11.5649L11.0459 22.4543C11.3318 23.4752 12.3037 24.1557 13.3328 24.1557C14.6477 24.1557 15.7339 23.0781 15.7339 21.7737C15.7911 21.5468 15.7339 21.32 15.6767 21.0364C15.6767 21.0931 15.6767 21.0931 15.6767 21.0364Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4229 21.0363L20.1932 14.4006C20.1932 14.4006 20.1932 14.4006 20.1932 14.3439C19.8502 13.4932 18.9355 12.8693 17.9636 12.8693C16.6487 12.8693 15.5624 13.9469 15.5624 15.2514C15.5624 15.5349 15.6196 15.8185 15.6768 16.0454L17.8493 22.4542C18.1351 23.4751 19.107 24.1557 20.1361 24.1557C21.451 24.1557 22.5372 23.0781 22.5372 21.7736C22.5372 21.5468 22.5372 21.3199 22.4229 21.0363C22.4229 21.0931 22.4229 21.0931 22.4229 21.0363Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0246 11.5649C25.9674 11.4515 25.9674 11.3948 25.9102 11.2813C25.9102 11.2813 25.9102 11.2813 25.9102 11.2246C25.9102 11.2246 25.9102 11.1679 25.8531 11.1112C25.8531 11.1112 25.8531 11.0545 25.7959 11.0545C25.6244 10.7709 24.824 9.69331 23.3947 8.61572C23.0517 8.38885 22.6515 8.27542 22.2513 8.44557C21.8511 8.61572 21.5653 8.89929 21.5081 9.35302C21.2794 10.4873 21.2223 12.1321 21.5081 13.0395V13.0962C21.5653 13.2664 21.6225 13.4365 21.7368 13.6067C22.1942 14.4007 22.9945 14.8544 23.8521 14.8544C24.138 14.8544 24.4238 14.7977 24.7097 14.6843C25.3385 14.4574 25.7959 14.0037 26.0817 13.4365C26.1961 12.8127 26.2533 12.1321 26.0246 11.5649Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cb8ecb068c4b657a110d2d72d608af03.svg";
export { ForwardRef as ReactComponent };